<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Incoming Call Logs</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getIncomingCallLogs($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <TabView v-if="userdatadisplayflag">
        <TabPanel header="Incoming Call Log">
            <div class="card">
                <DataTable :value="incomingCallLogs" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="incomingCallCount" :loading="loading" @page="onPageChange" class="p-datatable-users"
                    data-key="ld1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column header="Sr." headerStyle="width: 4%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column field="datatime" header="Date Time" headerStyle="width: 17%" bodyStyle="width: 17%">
                        <template #body="{ data }">
                            <div>
                                {{ format_datetime(data.datetime) }}
                            </div>
                        </template>
                    </Column>
                    <Column field="virtualnumber" header="Virtual Number" headerStyle="width: 10%"
                        bodyStyle="width: 10%">
                        <template #body="{ data }">
                            <div class="text-capitalize">{{ data.li8 ? data.li8 : "N/A" }}
                            </div>
                        </template>
                    </Column>
                    <Column field="callernumber" header="Caller Number" headerStyle="width: 10%" bodyStyle="width: 10%">
                        <template #body="{ data }">
                            <div>
                                {{ data.li12 ? data.li12 : "N/A" }}
                            </div>
                        </template>
                    </Column>
                    <Column field="callstatus" header="Call Status" headerStyle="width: 10%" bodyStyle="width: 10%">
                        <template #body="{ data }">
                            <span>{{ data.li18 ? data.li18 : "N/A" }}</span>
                        </template>
                    </Column>
                    <Column field="callduration" header="Call Duration" headerStyle="width: 8%" bodyStyle="width: 8%">
                        <template #body="{ data }">
                            <span>{{ data.li14 ? data.li14 : "00:00:00" }}</span>
                        </template>
                    </Column>
                    <Column field="billduration" header="Bill Duration" headerStyle="width: 8%" bodyStyle="width: 8%">
                        <template #body="{ data }">
                            <span>{{ data.li46 ? data.li46 : "00:00:00" }}</span>
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
</template>
<script>
import ApiService from '../../service/ApiService';
import moment from 'moment';

export default {
    data() {
        return {
            adminList: [],
            page_no: 0,
            incomingCallCount: 0,
            loading: false,
            incomingCallLogs: [],
            emp_name: '',
            userdatadisplayflag: false,
            admin_id: '',
            admin_list_status: false,
            itemsPerPage: 30,
            searchnamebtnactive: false,
            hidesearchname: false,
            searchfullname: '',
            searchnameloader: false,
            activate_read_key_arr: [],


        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.storage_path = JSON.parse(localStorage.masterBucketName);
        if (this.$store.state.adminId != null) {
            this.admin_id = this.$store.state.adminId;
            let adminId = this.$store.state.adminId;
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    let emp_name_id = data.data.records.filter(function (item) {
                        return item.value == adminId;
                    });
                    if (emp_name_id.length > 0) {
                        this.emp_name = emp_name_id[0];
                    }
                    this.getIncomingCallLogs();
                } else {
                    this.adminList = null;
                }
            });
        } else {
            this.getAdminListOnly();
        }
    },

    methods: {
        getAdminListOnly(e) {
            this.ApiService.getAdminListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    if (data.data.records.length == 1) {
                        this.getIncomingCallLogs({ value: data.data.records[0] });
                        this.emp_name = data.data.records[0];
                    }
                } else {
                    this.adminList = null;
                }
            });
        },
        getIncomingCallLogs(e) {
            this.userdatadisplayflag = true;
            this.loading = true;
            if (e) {
                this.admin_id = e.value.value;
            }
            this.activate_read_key_arr = [];
            this.ApiService.getIncomingCallLogs({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.incomingCallLogs = data.data;
                    this.incomingCallCount = data.count;
                    this.loading = false;
                    this.admin_list_status = true;

                    this.searchnameloader = false;
                    // this.searchmobloader = false;
                    this.hidesearchname = false;
                    this.hidesearchmob = false;
                }
            });
        },
        activateReadMore(e) {
            this.activate_read_key_arr.push(e);
        },

        deactivateReadMore(e) {
            var index = this.activate_read_key_arr.indexOf(e);
            if (index !== -1) {
                this.activate_read_key_arr.splice(index, 1);
            }
        },
        onPageChange(e) {
            this.loading = true;
            if (this.admin_list_status) {
                this.page_no = e.page;
                this.getIncomingCallLogs();
            }
        },
        searchFnameVoter(searchfullname) {
            this.hidesearchname = true;
            this.searchnameloader = true;
            this.lr14 = searchfullname;
            this.getIncomingCallLogs({
                page_no: this.page_no,
                lr14: this.lr14,
            });
            this.searchnamebtnactive = true;
        },
        searchNameVoterStop() {
            this.searchnamebtnactive = false;
            this.searchfullname = "";
            this.getIncomingCallLogs({
                page_no: this.page_no,
            });
            this.searchnameloader = false;
        },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return 'N/A';
            }
        },

        replacebrake(html) {
            const doc = html;
            return doc.replace(/(\r)*\n/g, '<br>');
        },
        decodeHtml(html) {
            return JSON.parse('"' + html + '"');
        },
        format_datetime(value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return '-';
            }
        },
    },
};
</script>
<style scoped lang="scss">
.custom-form-group {
    display: flex;
    align-items: center;
}
</style>
